module.exports = __webpack_public_path__ + "static/sales-funnel-icon-ed901203e553acab2eea7f9bed8363af.png";